import React from 'react'
import { Helmet } from 'react-helmet-async';
import MicroFrontend from "../MicroFrontend"
import { WEB_URL } from '../utilities/endpoints';

const NoMatch = ({ history }) => {
    return <>
        <Helmet
            title="404 page not found"
            link={[
                {
                    rel: 'canonical',
                    href: `${WEB_URL}/not-found`,
                },
            ]}
            meta={[
                {
                    name: 'description',
                    content: 'Sorry, page not found',
                },
                {
                    name: 'abstract',
                    content: 'Sorry, page not found',
                },
                {
                    property: 'og:url',
                    content: `${WEB_URL}/not-found`,
                },
                {
                    property: 'og:title',
                    content: '404 page not found',
                },
            ]}
            script={[
                {
                    type: 'application/ld+json',
                    innerHTML: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "BreadcrumbList",
                        "itemListElement": [{
                            "@type": "ListItem",
                            "position": 1,
                            "name": "404 page",
                            "item": `${WEB_URL}/not-found`
                        }]
                    })
                }
            ]}
        />
        <MicroFrontend
            history={history}
            name="NoMatch"
        />
    </>
}

export default (NoMatch);